import { IonButton } from '@ionic/react';
import { ButtonProps } from '../button/base-button';
import { PaywallModalWrapper } from './paywall-modal-wrapper';
import { PaywallComponentBaseProps } from './paywall.types';

export interface PaywallIonButtonProps extends PaywallComponentBaseProps {
  ionButtonProps?: ButtonProps;
}

const PaywallIonButton = (props: PaywallIonButtonProps) => {
  const { planEntitlementKey, isFeatureAvailable, ionButtonProps, children } =
    props;

  return (
    <PaywallModalWrapper planEntitlementKey={planEntitlementKey}>
      {({ presentUpgrade, hasEntitlement }) => {
        const isAvailable = isFeatureAvailable
          ? isFeatureAvailable(hasEntitlement)
          : hasEntitlement;

        return (
          <IonButton
            {...ionButtonProps}
            onClick={(e) => {
              if (isAvailable) {
                if (typeof ionButtonProps?.onClick === 'function') {
                  ionButtonProps?.onClick(e);
                }
              } else {
                e.stopPropagation();
                e.preventDefault();
                presentUpgrade();
              }
            }}
          >
            {children}
          </IonButton>
        );
      }}
    </PaywallModalWrapper>
  );
};

export { PaywallIonButton };
